import React from 'react';

import BulkActions from './BulkActions';
import CandidatesTableActions from './CandidatesTableActions';

/**
 * @component ActionsSection
 * @description Componente que representa la sección de acciones en la parte superior de la tabla de candidatos.
 * Muestra un botón para filtros, y dependiendo de si hay filas seleccionadas, muestra acciones masivas (`BulkActions`) o controles estándar (`CandidatesTableActions`).
 *
 * @param {Object} props
 * @param {Object} props.selectedRowIds - Objeto que contiene los IDs de las filas seleccionadas.
 * @param {Function} props.handleShow - Función que se ejecuta al hacer clic en el botón de filtro.
 * @param {Function} props.handleOpen - Función que se ejecuta al hacer clic en el botón "Nuevo".
 * @param {Function} props.handleLoad - Función que se ejecuta al cargar candidatos desde archivo.
 *
 * @returns {JSX.Element} Sección con botones de acciones condicionales.
 *
 * @example
 * <ActionsSection
 *    selectedRowIds={selected}
 *    handleShow={toggleFilters}
 *    handleOpen={openCreateModal}
 *    handleLoad={loadCandidatesFromFile}
 * />
 */
const ActionsSection = ({ selectedRowIds, handleOpen, handleLoad, onBulkAction }) => (
    <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        {Object.keys(selectedRowIds).length > 0 ? (
            <BulkActions onBulkAction={onBulkAction} />
        ) : (
            <CandidatesTableActions handleOpen={handleOpen} handleLoad={handleLoad} />
        )}
    </div>
);

export default ActionsSection;